import React from "react";
import { Modal } from "seed/helpers";
import l from "components/util/l";
import CollectionFormEdit from "components/collections/forms/CollectionFormEdit";
import CollectionFormCreate from "components/collections/forms/CollectionFormCreate";

const SettingsView = ({
  flow,
  collections,
  activeCollectionId,
  defaultCollectionType,
  isCreateModalOpen,
  isEditModalOpen,
  setDefaultCollectionType,
  setIsCreateModalOpen,
  setIsEditModalOpen,
  onMoveUp,
  onMoveDown,
  onEdit,
  onDelete,
  onChangeVisibility,
  refetchCollections,
}) => (
  <div className="card">

    <div className="card-header">
      <div className="d-flex justify-content-between align-items-center w-100">
        <h3 className="mb-0">
          {l("Datos%GA035")}
        </h3>
        <div>
          <div className="dropdown">

            <button
              id="create-table-dropdown"
              className="btn btn-outline-primary-white dropdown-toggle"
              type="button"
              //data-toggle="dropdown"
              //aria-expanded="false"
              onClick={() => {
                setIsCreateModalOpen(true);
                setDefaultCollectionType("TABLE");
              }}
            >
              <span>
                <i className="fas fa-plus mr-2 tab-icon"></i>
                <span>
                  {l("Crear tabla%CA004")}
                </span>
              </span>
            </button>

            {/* Temp hide
            <div id="create-table-dropdown-content">
              <div>
                <div className="dropdown-menu" aria-labelledby="create-table-dropdown">

                  <StyleTag
                    content={`
                      #create-table-dropdown-sub:hover .dropdown-menu {
                        display: block;
                      }
                      #create-table-dropdown-submenu {
                        display: none;
                        position: absolute;
                        left: 100%;
                        top: 0;
                        z-index: 9999;
                      }
                    `}
                  />

                  <span
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIsCreateModalOpen(true);
                      setDefaultCollectionType("TABLE");
                    }}
                  >
                    <div>
                      <i className="tio-table dropdown-item-icon"></i>
                      <span>Crear tabla</span>
                    </div>
                  </span>

                  <span
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIsCreateModalOpen(true);
                      setDefaultCollectionType("LIST");
                    }}
                  >
                    <div>
                      <i className="fas fa-list dropdown-item-icon"></i>
                      <span>Crear lista</span>
                    </div>
                  </span>

                  <span
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIsCreateModalOpen(true);
                      setDefaultCollectionType("DOCUMENT");
                    }}
                  >
                    <div>
                      <i className="tio-folder dropdown-item-icon"></i>
                      <span>Crear carpeta de archivos</span>
                    </div>
                  </span>

                </div>
              </div>
            </div>
            */}

          </div>
        </div>

      </div>
    </div>

    <div className="card-body px-4">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th className="text-capitalize text-start">
              {l("Nombre%GA074")}
            </th>
            <th className="text-capitalize text-start"></th>
          </tr>
        </thead>
        <tbody>
          {
            collections.map((collection, index) => (
              <tr key={index}>
                <td className="text-capitalize text-start">
                  <div className="d-flex align-items-center py-2">
                    {collection?.uiSettings?.label ?? collection.name}
                  </div>
                </td>
                <td
                  className="text-center"
                  style={{
                    width: "45%",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary mr-1"
                    onClick={() => {
                      onMoveUp(index);
                    }}
                  >
                    <i className="fas fa-arrow-up"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary mr-1"
                    onClick={() => {
                      onMoveDown(index);
                    }}
                  >
                    <i className="fas fa-arrow-down"></i>
                  </button>

                  <button
                    type="button"
                    className={"btn btn-sm mr-3 " + 
                      (!collection.settings?.is_hidden ? "btn-outline-secondary " : "btn-secondary ")}
                    onClick={() =>
                      onChangeVisibility(collection.id, !collection.settings?.is_hidden)}
                  >
                    <i className={`fas ${collection.settings?.is_hidden ? "fa-eye-slash" : "fa-eye"}`}></i>
                  </button>

                  <button
                    type="button"
                    className="btn btn-sm btn-primary mr-2"
                    onClick={() => {
                      onEdit(collection.id);
                    }}
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-danger"
                    onClick={() => {
                      onDelete(collection.id);
                    }}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>

    {
      isEditModalOpen && <Modal
        width="600"
        height="550"
        flow={flow}
        onSet={refetchCollections}
        collectionId={activeCollectionId}
        onClose={() => setIsEditModalOpen(false)}
        component={CollectionFormEdit}
      />
    }

    {
      isCreateModalOpen && <Modal
        width="600"
        height="550"
        flow={flow}
        onSave={refetchCollections}
        onClose={() => setIsCreateModalOpen(false)}
        component={CollectionFormCreate}
        defaultCollectionType={defaultCollectionType}
      />
    }

  </div>
)

export default SettingsView;